<div class="page-section">
    <div class="page-section-header">
        <h1>NPS Survey</h1>
    </div>
    <popup-loader *ngIf="isloaded"></popup-loader>
    <div class="page-section-content">
        <div class="form-wrapper">
            <form novalidate [formGroup]="npsSurveyForm" (ngSubmit)="doSave()">
                <div formArrayName="mainQuestion"
                    *ngFor="let qn of npsSurveyForm.get('mainQuestion')['controls']; let i = index">
                    <div [formGroupName]="i">
                        <div class="wt-scale-qn1">
                            <label>{{qn.value.comment}}</label>
                            <app-number-scale [scaleIndex]="i" [scaleOptionValues]="qn.value.options"
                                (onCompleted)="scaleSelectionCompleted($event)"></app-number-scale>
                            <div class="error-message" *ngIf="isSubmitted && !npsSUrveyFinalData[i]?.value">
                                Please select the range value
                            </div>
                        </div>

                        <div>
                            <div formArrayName="subQuestion"
                                *ngFor="let subQn of qn.get('subQuestion')['controls']; let j = index">
                                <div [formGroupName]="j">
                                    <div class="app-c-form-group" *ngIf="subQn.value.show">
                                        <label class="app-c-form--label" for="subAnswer_{{i}}_{{j}}">{{subQn.value.comment}}</label>
                                        <textarea
                                            aria-label="answer"
                                            class="app-c-form-control"
                                            id="subAnswer_{{i}}_{{j}}"
                                            formControlName="answer"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fixed-footer">
                    <button tabindex="0" class="btn-primary btn">
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
